<topo-dialog
  [dialogRef]="dialogRef"
  hideHeaderClose>
  <div class="dialog-content">
    @if (!!props?.icon) {
      @let iconColor = props.isDangerous ? 'var(--red-800)' : 'var(--primary-color-600)';
      <topo-icon
        [props]="{
          type: 'system',
          path: props.icon,
          style: {
            height: '90px',
            width: '90px',
            fontSize: '50px',
            color: iconColor,
            borderStyle: 'solid',
            borderColor: iconColor,
            borderWidth: '2px',
            borderRadius: '999rem'
          }
        }" />
    }

    <h5>{{ title() }}</h5>

    <div
      class="message"
      [style.textAlign]="messageAlignment"
      [innerHTML]="message()"></div>

    @if (props?.listItems?.length) {
      <br />
      @for (item of props.listItems; track $index) {
        <li>{{ item }}</li>
      }
    }
  </div>

  <div
    class="dialog-footer"
    ngProjectAs="dialog-footer">
    @if (!props.hideCancel) {
      <button
        type="button"
        class="button is-medium is-secondary"
        (click)="dialogRef.close(false)">
        {{ cancelBtnText() }}
      </button>
    }
    <button
      type="button"
      [class]="confirmBtnClass()"
      [disabled]="disableConfirm()"
      (click)="dialogRef.close(true)">
      {{ confirmBtnText() }}
    </button>
  </div>
</topo-dialog>
